import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AssistantState } from './types';

export const initialState: AssistantState = {
  isOpen: false,
  threadId: undefined,
};

const assistantSlice = createSlice({
  name: 'assistant',
  initialState,
  reducers: {
    setThreadId: (state, action: PayloadAction<string | undefined>) => ({ ...state, threadId: action.payload }),
    toggleAssistant: (state) => ({ ...state, isOpen: !state.isOpen }),
  },
});

export const { setThreadId, toggleAssistant } = assistantSlice.actions;
export default assistantSlice.reducer;
